import { BAGS_TO_BLOCKS } from '../types/index';
export function toDate(dateStr) {
    const [y, m, d] = dateStr.slice(0, 10).split('-').map(Number);
    return new Date(y, (m ?? 1) - 1, d ?? 1);
}
function isoFromDate(d) {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
}
export function weekStartISO(dateStr) {
    const d = toDate(dateStr);
    const day = d.getDay(); // 0=Sun .. 6=Sat
    const offset = day === 0 ? -6 : 1 - day; // Monday as start
    d.setDate(d.getDate() + offset);
    return isoFromDate(d);
}
export function monthStartISO(dateStr) {
    const d = toDate(dateStr);
    d.setDate(1);
    return isoFromDate(d);
}
export function buildInventoryTimeline(items, refills) {
    // Gather daily changes: arrivals add blocks; refills subtract blocks
    const changes = new Map();
    for (const item of items) {
        if (item.status === 'arrived' && item.dateArrived) {
            const iso = item.dateArrived.slice(0, 10);
            const blocks = item.quantityBags * BAGS_TO_BLOCKS;
            changes.set(iso, (changes.get(iso) ?? 0) + blocks);
        }
    }
    for (const r of refills) {
        const iso = r.date;
        const blocks = Number.isFinite(r.blocks) ? r.blocks : 0;
        changes.set(iso, (changes.get(iso) ?? 0) - blocks);
    }
    const dates = Array.from(changes.keys()).sort();
    const timeline = [];
    let running = 0;
    for (const iso of dates) {
        const delta = changes.get(iso) ?? 0;
        running += delta;
        const refillBlocks = delta < 0 ? Math.abs(delta) : 0;
        timeline.push({ date: iso, inventoryBlocks: Math.max(0, running), refillBlocks });
    }
    return timeline;
}
export function binTimeline(timeline, bin) {
    const bucketMap = new Map();
    for (const p of timeline) {
        const bucket = bin === 'weekly' ? weekStartISO(p.date) : monthStartISO(p.date);
        const curr = bucketMap.get(bucket) ?? { inv: 0, ref: 0 };
        // For inventory, take last value in the bucket to represent the end-of-period level
        curr.inv = p.inventoryBlocks;
        curr.ref += p.refillBlocks;
        bucketMap.set(bucket, curr);
    }
    const labels = Array.from(bucketMap.keys()).sort();
    const inventory = labels.map(l => bucketMap.get(l).inv);
    const refills = labels.map(l => bucketMap.get(l).ref);
    return { labels, inventory, refills };
}
